import { render, staticRenderFns } from "./TibetRealNamePopup.vue?vue&type=template&id=54605010&scoped=true&"
import script from "./TibetRealNamePopup.vue?vue&type=script&lang=js&"
export * from "./TibetRealNamePopup.vue?vue&type=script&lang=js&"
import style0 from "./TibetRealNamePopup.vue?vue&type=style&index=0&id=54605010&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../layers/paketo-buildpacks_npm-install/build-modules/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54605010",
  null
  
)

export default component.exports